import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

const STORAGE_KEY = 'sa_cookie_ack';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Lê depois do mount pra não causar hydration mismatch caso vire SSR no futuro.
    try {
      const ack = localStorage.getItem(STORAGE_KEY);
      if (!ack) setVisible(true);
    } catch {
      // localStorage indisponível (cookies bloqueados, modo privado restritivo).
      // Não mostra banner — sem onde gravar consentimento, fica chato repetir.
    }
  }, []);

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* sem storage; ok */
    }
    setVisible(false);
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="dialog"
          aria-label="Aviso sobre cookies"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="fixed inset-x-4 bottom-4 z-50 sm:left-auto sm:right-6 sm:max-w-md"
        >
          <div
            className="card-paper-strong rounded-sm px-5 py-4"
            style={{ borderLeft: '3px solid var(--accent-saffron)' }}
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              cookies
            </p>
            <p className="mt-2 font-serif text-[15px] leading-snug text-[var(--ink-primary)]">
              Usamos só cookies essenciais pra autenticação, segurança e voto no roadmap.
            </p>
            <p className="mt-2 font-sans text-xs leading-relaxed text-[var(--ink-secondary)]">
              Nada de tracker de marketing, Google Analytics ou pixel de rede social. Detalhes na{' '}
              <a
                href="#/cookies"
                className="text-[var(--accent-saffron)] underline underline-offset-2 hover:text-[var(--ink-primary)]"
              >
                Política de Cookies
              </a>
              .
            </p>
            <div className="mt-4 flex items-center justify-end gap-3">
              <a
                href="#/cookies"
                className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)] hover:text-[var(--ink-primary)]"
              >
                ver detalhes
              </a>
              <button
                type="button"
                onClick={dismiss}
                className="rounded-sm bg-[var(--ink-primary)] px-4 py-1.5 font-sans text-sm text-[var(--bg-paper)] hover:opacity-90"
              >
                Entendi
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
